export const NEAR_METERS = 150;

export function getPosition(timeout = 8000) {
  return new Promise((resolve) => {
    if (!navigator.geolocation) return resolve(null);
    navigator.geolocation.getCurrentPosition(
      (p) => {
        const pos = { lat: +p.coords.latitude.toFixed(6), lng: +p.coords.longitude.toFixed(6) };
        try { localStorage.setItem("fhp-last-pos", JSON.stringify({ lat: +pos.lat.toFixed(1), lng: +pos.lng.toFixed(1) })); } catch { /* private mode */ }
        resolve(pos);
      },
      () => resolve(null),
      { enableHighAccuracy: true, timeout, maximumAge: 120000 }
    );
  });
}

// Only true when the driver already allowed location, so we never pop a prompt unasked.
export async function locationGranted() {
  try {
    const st = await navigator.permissions?.query({ name: "geolocation" });
    return st ? st.state === "granted" : null;
  } catch { return null; }
}

export function distanceM(a, b) {
  const R = 6371000, rad = (x) => (x * Math.PI) / 180;
  const dLat = rad(b.lat - a.lat), dLng = rad(b.lng - a.lng);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

export function nearestSite(sites, pos) {
  let best = null;
  for (const s of sites) {
    if (s.lat == null || s.lng == null) continue;
    const d = distanceM(pos, s);
    if (d <= NEAR_METERS && (!best || d < best.d)) best = { site: s, d };
  }
  return best;
}
